import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../api/client.js";
import {
  clearAdminToken,
  getAdminToken,
  setAdminToken,
} from "../admin/auth.js";
import "../Style/Admin.css";

function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const token = getAdminToken();
    if (!token) return;

    api.admin
      .me(token)
      .then(() => navigate("/admin", { replace: true }))
      .catch(() => clearAdminToken());
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const response = await api.auth.login(credentials);
      setAdminToken(response.data.accessToken);
      navigate(location.state?.from || "/admin", { replace: true });
    } catch (requestError) {
      setError(requestError.message || "Admin login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="admin-auth-page">
      <section className="admin-login-card">
        <p className="admin-eyebrow">Up &amp; Away Admin</p>
        <h1>Admin login</h1>
        <p className="admin-login-intro">
          This private area is restricted to the single administrator account.
        </p>

        <form onSubmit={handleSubmit}>
          <label>
            <span>Email address</span>
            <input
              type="email"
              autoComplete="username"
              value={credentials.email}
              onChange={(event) =>
                setCredentials((current) => ({
                  ...current,
                  email: event.target.value,
                }))
              }
              required
            />
          </label>

          <label>
            <span>Password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={credentials.password}
              onChange={(event) =>
                setCredentials((current) => ({
                  ...current,
                  password: event.target.value,
                }))
              }
              required
            />
          </label>

          {error && (
            <p className="admin-form-error" role="alert">
              {error}
            </p>
          )}

          <button type="submit" disabled={submitting}>
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </section>
    </main>
  );
}

export default AdminLogin;
